export function cx(...args: any[]) {
  return args.filter(Boolean).join(' ')
}



// WEBPACK FOOTER //
// ./src/v1/components/lib/cx.ts